import React, { Component } from 'react';
import moment from 'moment';
import { translate, getLanguages } from '../services';
import { SvgImage } from '.';
import { closeIcon } from '../../style/images';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { aboutState } from '../store';

const getFormattedDate = ( dateString, withTime = false ) => {
  return moment( dateString ).locale( getLanguages().first() ).format( withTime ? 'LLLL' : 'dddd, LL' );
};

const capitalizeFirstLetter = string => string.charAt( 0 ).toUpperCase() + string.slice( 1 );

const ChangeItem = ( { change, onClick } ) => {
  const click = () => onClick( change.link );

  return <li>
    { getFormattedDate( change.date ) }
    <span> - </span>
    <a onClick={ click }>{ translate( change.title ) }</a>
  </li>; 
};

export class AboutWindowComponent extends Component {
  hidePopup = () => {
    this.props.hidePopup();
  }

  goToLink = link => {
    const { router } = this.context;
    router && router.history.push( link );
    this.hidePopup();
  }

  renderChangeLog() {
    const { about } = this.props;

    if( !about.changelog || !about.changelog.length ) {
      return null;
    }

    return about.changelog.map( ( change, key ) => <ChangeItem key={ key } change={ change } onClick={ this.goToLink }/> );
  }

  render() {
    const { about } = this.props;
    const lastupdate = getFormattedDate( about.lastUpdate, true );
    const offices = about.offices && Object.keys( about.offices ).map( key => 
      <div key={ key }>
        <h5>{ capitalizeFirstLetter( key ) }</h5>
        <span>{ about.offices[key] }</span>
      </div> 
    );

    return <div className="about-window">
      <div className="about-window-header">
        <h1>{ 'e-Configure' }</h1>
        <SvgImage source={ closeIcon } onClick={ this.hidePopup }/>
      </div>
      <div className="about-window-content-panel">
        <h4>{ translate( 'Application version: {version}', { version: about.version } ) }</h4>
        <span>{ translate( 'Last update: {lastupdate}', { lastupdate } ) }</span>
        <h4>{ translate( 'What\'s New' ) }</h4>
        <ul>{ this.renderChangeLog() }</ul>
        <h4>{ translate( 'Contact us' ) }</h4>
        <span>
          { translate( 'ABB Technical Service: ' ) } 
          <a href={ `mailto:${about.contact}` }>{ about.contact }</a>
        </span>
        <div className="about-window-offices">
          { offices }
        </div>
      </div>
    </div>;
  }
}

AboutWindowComponent.propTypes = {
  about: PropTypes.shape( {
    changelog: PropTypes.arrayOf( PropTypes.shape( {
      date: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    } ) ),
    contact: PropTypes.string.isRequired,
    lastUpdate: PropTypes.string.isRequired,
    offices: PropTypes.shape( {} ),
    version: PropTypes.string.isRequired
  } ),
  hidePopup: PropTypes.func.isRequired
};

AboutWindowComponent.contextTypes = {
  router: PropTypes.object
};

export const AboutWindow = connect( aboutState )( AboutWindowComponent );